import { useEffect, useState } from "react";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Displays a product image. If `image2` is provided, alternates between the two
 * images every `intervalMs` (default 3000ms) with a smooth cross-fade.
 * Falls back to the placeholder when both images are missing.
 */
const ProductImage = ({
  image,
  image2,
  alt,
  className = "",
  intervalMs = 3000,
  placeholder = "📦",
}) => {
  const hasFirst = Boolean(image);
  const hasSecond = Boolean(image2);
  const cycle = hasFirst && hasSecond;
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!cycle) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % 2), intervalMs);
    return () => clearInterval(t);
  }, [cycle, intervalMs]);

  if (!hasFirst && !hasSecond) {
    return (
      <div className={`flex items-center justify-center text-4xl bg-[#F3F6F4] ${className}`}>
        <span>{placeholder}</span>
      </div>
    );
  }

  if (!cycle) {
    return (
      <img
        src={`${API_BASE}/files/${image || image2}`}
        alt={alt || ""}
        className={`object-contain ${className}`}
        loading="lazy"
        decoding="async"
      />
    );
  }

  // both images present — cross-fade between them
  return (
    <div className={`relative ${className}`}>
      <img
        src={`${API_BASE}/files/${image}`}
        alt={alt || ""}
        loading="lazy"
        decoding="async"
        className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-500 ${idx === 0 ? "opacity-100" : "opacity-0"}`}
      />
      <img
        src={`${API_BASE}/files/${image2}`}
        alt={alt || ""}
        loading="lazy"
        decoding="async"
        className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-500 ${idx === 1 ? "opacity-100" : "opacity-0"}`}
      />
    </div>
  );
};

export default ProductImage;
